import { render, staticRenderFns } from "./ModuleBalance.vue?vue&type=template&id=9329f49e"
import script from "./ModuleBalance.vue?vue&type=script&lang=js"
export * from "./ModuleBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports